export const jobCategoryData = [
    "Accountant",
    "Cook / Waiter / Hotel Staff",
    "Delivery",
    "Manufacturing (Machine Operator, Linesman etc.)",
    "Electrician / Fitter / Welder",
    "Front Office / Retail",
    "Sales & Marketing",
    "Security Guard",
    "Tele-Caller / BPO",
    "Nurse / Ward Boy / Hospital Staff",
    "House Keeping",
    "Construction (Masons, Electrician, Welders, Architect etc.)",
    "Driver",
    "Automobile Service",
    "Bakery",
    "Beautician / Spa / Wellness",
    "Medical Representative / Pharma",
    "Airlines",
    "Dairy",
    "Garment Making / Tailor",
    "IT / Hardware / Network Engineer",
    "Paint Shop / Automobile Factory",
    "Petrol Pump",
    "Gardening / Landscape / Nursery",
    "Solar & Battery",
    "Telecom  / Tower Technician",
    "Back Office / Data Entry",
    "Domestic Help (maid, nanny, caretaker etc.)",
    "Teacher",
    "Legal",
    "Event Management",
    "Lab technician",
    "Admin / Office Help / Peon",
    "HR / Receptionist"
]